export const storiesCategory = "VectorfieldAnimation/";
